import { mapState } from 'vuex'

export default {
  name: 'AxaptBillsList',
  props: {
    clientReportId: {
      type: String | Number,
      default: null
    }
  },
  data () {
    return {
      isMounted: false,
      loading: true,
      currentReq: null,
      tableItems: [],
      filterValues: {
        clientName: '',
        axaptOrderNumber: '',
        bill_number: '',
        reportSubCode: null,
        datePeriodId: null
      },
      paging: { limit: 50, page: 1, total: 0, pages: 0 }
    };
  },
  computed: {
    ...mapState(['config']),
    isD365BillingEnabled () {
      return !!this.BasicHelper.getObjectValueByString(this.config, 'plugins.d365_api.enabled');
    },
    tableHeaders () {
      const headers = [
        { key: 'axapt_bill.file', label: this.$t('axaptbills.axaptfile'), type: 'actionlinks', singlefile: true, emit: 'downloadAxaptFile', actionNameParam: 'filename', ifconfig: { param: 'id', value: null, notCheck: true } },
        { key: 'advance_client_bill.file', label: this.$t('axaptbills.advancebill'), type: 'actionlinks', singlefile: true, emit: 'downloadAdvanceBill', actionFunc: this.getAdvBillname, ifconfig: { param: 'id', value: null, notCheck: true } },
        { key: 'real_client_bill.file', label: this.$t('axaptbills.realbill'), type: 'actionlinks', singlefile: true, emit: 'downloadRealBill', actionFunc: this.getRealBillname, ifconfig: { param: 'id', value: null, notCheck: true }, filterKey: 'bill_number' },
        { key: 'axaptOrderNumber', label: this.$t('axaptbills.axaptOrderNumber'), filterKey: 'axaptOrderNumber' },
        { key: 'd365SalesOrderNumber', label: this.$t('axaptbills.d365SalesOrderNumber'), filterKey: 'd365SalesOrderNumber' },
        { key: 'axapt_bill.sentAt', label: this.$t('axaptbills.sentAt'), type: 'datetime' },
        { key: 'axapt_bill.importedAt', label: this.$t('axaptbills.importedAt'), type: 'datetime' },
        { key: 'axapt_bill.sendToAxapta', label: this.$t('axaptbills.sendToAxapta'), format: 'formatYesNo' },
        { key: 'billedTotal', label: this.$t('axaptbills.billedTotal'), format: 'decimal', precision: 2 },
        { key: 'client.balance', label: this.$t('client.balanceAxapta'), format: 'formatDecimal', precision: 2 }
      ];
      if (!this.clientReportId) {
        headers.unshift({ key: 'client_report.date_period_id', label: this.$t('bill.date_period_id'), format: 'formatDatePeriod', filterKey: 'datePeriodId' });
        headers.unshift({
          key: 'client_report.report_config_id',
          label: this.$t('bill.report'),
          type: 'actionlinks',
          emit: 'viewreport',
          actionFormat: 'formatFromConfig',
          configKey: 'report_configs',
          configParam: 'name',
          filterKey: 'reportSubCode'
        });
        headers.unshift({ key: 'client.name', label: this.$t('client.name'), type: 'routelink', routeTo: 'menu.client.edit', params: { clientApiId: 'client.api_id' }, filterKey: 'clientName' });
      }
      if (this.canEdit) {
        const isD365BillingEnabled = this.isD365BillingEnabled;
        const actions = [
          { label: this.$t('menu.axaptbills.regenerateAdvanceBillPdf'), emit: 'regenerateAdvanceBillPdf', bicon: 'list-ul', class: 'btn-adv-bill' },
          { label: this.$t('menu.axaptbills.regenerateRealBillPdf'), emit: 'regenerateRealBillPdf', bicon: 'file-text', ifconfig: { param: 'real_client_bill.id', value: null, notCheck: true, disableNotHide: true }, class: 'btn-real-bill' },
          {
            label: this.$t('menu.axaptbills.sendToAxapta'),
            emit: 'sendToAxapta',
            bicon: 'cloud-upload',
            ifconfig: {
              useFunc: true,
              func: function (item) {
                return !isD365BillingEnabled && !item.d365SalesOrderNumber && !(item.axapt_bill && item.axapt_bill.sentAt);
              }
            },
            class: 'btn-download'
          },
          {
            label: this.$t('menu.axaptbills.sendToD365'),
            emit: 'sendToD365',
            bicon: 'cloud-upload',
            ifconfig: {
              useFunc: true,
              func: function (item) {
                return isD365BillingEnabled && item.can_send_to_d365;
              },
              disableNotHide: true
            },
            class: 'btn-download'
          },
          {
            label: this.$t('menu.axaptbills.delete'),
            emit: 'deleteItem',
            icon: 'delete',
            bicon: 'trash',
            ifconfig: {
              useFunc: true,
              func: function (item) {
                return !item.d365RealBillNumber;
              },
              disableNotHide: true
            }
          }
        ];
        headers.push({ key: 'actions', label: '', actions: actions, class: 'col-width-large' });
      }
      return headers;
    },
    reportNameOptions () {
      return this.ZPFormatHelper.getReportNameOptions(false, true);
    },
    canEdit () {
      return this.ApiRequest.userHasPermission('edit-axbills');
    },
    tableFilterConfig () {
      const filters = { };
      filters.reportSubCode = { type: 'select', label: this.$t('client.filters.reportSubCode'), options: this.reportNameOptions, colOnlyFilter: true };
      filters.datePeriodId = { type: 'date-period', label: this.$t('general.filters.date-period'), colOnlyFilter: true }
      filters.clientName = { type: 'text', label: this.$t('client.name'), colOnlyFilter: true }
      filters.bill_number = { type: 'text', label: '', colOnlyFilter: true };
      filters.axaptOrderNumber = { type: 'text', label: this.$t('axaptbills.axaptOrderNumber'), colOnlyFilter: true }
      return filters;
    }
  },
  methods: {
    getTableData () {
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }
      this.loading = true;
      const self = this;
      let path = 'axaptbills/list';
      if (this.clientReportId) {
        path += '/' + this.clientReportId;
      } else {
        path += '?perPage=' + this.paging.limit + '&page=' + this.paging.page;
      }
      let filterValues = [];
      if (this.$refs.tableview) {
        filterValues = this.$refs.tableview.getFilterValues();
      }
      this.currentReq = this.ApiRequest.request(path, this.ApiRequest.REQUEST_POST, filterValues, function (response) {
        if (response.data) {
          self.tableItems = response.data;
          self.paging = response.paging;
          self.loading = false;
        }
      });
    },
    setDeleted (el) {
      this.loading = true;
      const self = this;
      this.ApiRequest.request('axaptbills/delete/' + el.axapt_bill.id, this.ApiRequest.REQUEST_POST, [], function (response) {
        if (response.error) {
          self.ApiRequest.displayErrorDialog(response, self);
          self.loading = false;
        } else {
          self.itemUpdated();
        }
      });
    },
    itemUpdated () {
      this.$emit('saved');
      this.getTableData();
    },
    editItem (el) {
      this.$refs.editElFrm.show(el);
    },
    deleteItem (el, approved) {
      if (approved) {
        this.setDeleted(el, 1);
      } else {
        this.$refs.itemDeleteMsgBox.show(el, this.$t('menu.axaptbills.deleteTitle'), this.$t('menu.axaptbills.deleteMessage', { userName: el.name }))
      }
    },
    changePage (pageNr) {
      this.paging.page = pageNr;
      this.getTableData();
    },
    downloadBill (idx, type) {
      const self = this;
      this.tableItems[idx][type].file.loading = true;
      this.$refs.tableview.$forceUpdate();
      this.ApiRequest.request('axaptbills/downloadfile/' + this.tableItems[idx][type].file.id, this.ApiRequest.REQUEST_DOWNLOAD, [], function (response) {
        if (response.error) {
          self.ApiRequest.displayErrorDialog(response, self);
        }
        self.tableItems[idx][type].file.loading = false;
        self.$refs.tableview.$forceUpdate();
      })
    },
    downloadAdvanceBill (idx) {
      this.downloadBill(idx, 'advance_client_bill');
    },
    downloadRealBill (idx) {
      this.downloadBill(idx, 'real_client_bill');
    },
    downloadAxaptFile (idx) {
      this.downloadBill(idx, 'axapt_bill');
    },
    regeneratePdf (el, type) {
      const self = this;
      el.loading = true;
      this.$refs.tableview.$forceUpdate();
      this.ApiRequest.request('axaptbills/recreate-pdf/' + el.id + '/' + type, this.ApiRequest.REQUEST_POST, [], function (response) {
        if (response.error) {
          self.ApiRequest.displayErrorDialog(response, self);
        }
        el.loading = false;
        self.$refs.tableview.$forceUpdate();
      });
    },
    regenerateAdvanceBillPdf (el) {
      this.regeneratePdf(el, 'ADVANCE');
    },
    regenerateRealBillPdf (el) {
      this.regeneratePdf(el, 'REAL');
    },
    sendToAxapta (el, approved = false) {
      if (approved) {
        el.loading = true;
        this.$refs.tableview.$forceUpdate();
        const self = this;
        this.ApiRequest.request('axaptbills/send-to-axapta/' + el.axapt_bill.id, this.ApiRequest.REQUEST_POST, [], function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self);
          }
          el.loading = false;
          self.$refs.tableview.$forceUpdate();
        });
      } else {
        this.$refs.itemSendToAxaptaMsgBox.show(el, this.$t('menu.axaptbills.sendToAxaptaTitle'), this.$t('menu.axaptbills.sendToAxaptaMessage', { userName: el.name }))
      }
    },
    sendToD365 (el, approved = false) {
      if (approved) {
        el.loading = true;
        this.$refs.tableview.$forceUpdate();
        const self = this;
        this.ApiRequest.request('axaptbills/send-to-d365/' + el.id, this.ApiRequest.REQUEST_POST, [], function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self);
            el.loading = false;
            self.$refs.tableview.$forceUpdate();
          } else {
            self.itemUpdated();
          }
        });
      } else {
        this.$refs.itemSendToD365MsgBox.show(el, this.$t('menu.axaptbills.sendToD365Title'), this.$t('menu.axaptbills.sendToD365Message'))
      }
    },
    viewreport (index, newtab = false) {
      const clientId = (this.tableItems[index].client ? this.tableItems[index].client.api_id : this.clientApiId)
      const clientReport = this.tableItems[index].client_report;
      const reportCode = this.$store.getters.getParamFromConfig('report_configs', clientReport.report_config_id, 'code');
      if (newtab) {
        const routeData = this.$router.resolve({ name: 'menu.client.report', params: { clientApiId: clientId, reportCode: reportCode, datePeriodCode: clientReport.date_period_id } });
        window.open(routeData.href, '_blank');
      } else {
        this.$router.push('/client/' + clientId + '/report/' + reportCode + '/' + clientReport.date_period_id);
      }
    },
    getAdvBillname (file, item) {
      if (file) {
        return item.advance_client_bill.bill_number + '.pdf';
      }
      return '';
    },
    getRealBillname (file, item) {
      if (file) {
        return item.real_client_bill.bill_number + '.pdf';
      }
      return '';
    }
  },
  mounted () {
    this.isMounted = true;
    this.getTableData();
  }
}
